import React, { useMemo } from 'react';

export function HotelLink({href, className}) {
    const title = useMemo(() => {
        const url = new URL(href);

        let title = url.hostname;

        if (title.indexOf('www.') > -1) {
            title = title.replace('www.', '');
        }

        if (title.length > 40) {
            title = title.slice(0, 37) + '...';
        }

        return title;
    }, [href]);

    return (
        <a
            href={href}
            className={className}
            target="_blank"
            rel="noreferrer"
        >
            {title}
        </a>
    );
}
